// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Column } from '@lfx/shared/interfaces';
import { BehaviorSubject } from 'rxjs';
import { SharedModule } from '@lfx/shared/shared.module';
import { ProfileSnapshotChildrenModule } from '../../profile-snapshot-children.module';

@Component({
  selector: 'lfx-employee-activity-card',
  imports: [CommonModule, SharedModule, ProfileSnapshotChildrenModule],
  templateUrl: './employee-activity-card.component.html',
  styleUrls: ['./employee-activity-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmployeeActivityCardComponent implements OnInit {
  sectionTitle = 'Activity';
  subTitle = '';

  columnsGroups = {
    Events: [
      {
        name: 'Event Name',
        prop: 'eventName',
        clickableText: true,
        linkableText: false,
        dataStyle: {
          fontWeight: '400',
          fontSize: '14px',
          color: '#009ADE',
        },
      },
      {
        name: 'Date',
        prop: 'date',
        clickableText: true,
        // sortable: true,
        sortDir: 'desc',
        dataStyle: {
          color: '#009ADE',
        },
      },
    ],
    Training: [
      {
        name: 'Course Name',
        prop: 'courseName',
        clickableText: true,
        linkableText: false,
        dataStyle: {
          fontWeight: '400',
          fontSize: '14px',
          color: '#009ADE',
        },
      },
      {
        name: 'Enrollment Date',
        prop: 'enrollmentDate',
        clickableText: true,
        // sortable: true,
        sortDir: 'desc',
        dataStyle: {
          color: '#009ADE',
        },
      },
    ],
  };

  columns: Column[] = null;
  chipsOptions = [
    {
      name: 'Technical',
      id: 'Technical',
    },
    {
      name: 'Events',
      id: 'Events',
    },
    {
      name: 'Training',
      id: 'Training',
    },
    {
      name: 'Meetings',
      id: 'Meetings',
    },
    {
      name: 'Subscriptions',
      id: 'Subscriptions',
    },
  ];

  @Input() userId: string;
  @Input() projectId?: string;
  @Input() defaultFilter?:
    | 'Technical'
    | 'Events'
    | 'Training'
    | 'Meetings'
    | 'Subscriptions';
  @Input() initialTimeRange?: string;

  selectedFilterItem: any;
  _timeRange: BehaviorSubject<string>;
  timeRange$;

  constructor() {}

  ngOnInit(): void {
    // Use initialTimeRange if provided, otherwise default to 'last_12mo'
    const defaultTimeRange = this.initialTimeRange || 'last_12mo';
    this._timeRange = new BehaviorSubject<string>(defaultTimeRange);
    this.timeRange$ = this._timeRange.asObservable();

    this.selectedFilterItem =
      this.chipsOptions.find(option => option.id === this.defaultFilter) ||
      this.chipsOptions[0];
  }

  updateTimeRange(event) {
    this._timeRange.next(event);
  }
}
